import React, { useContext, useCallback } from 'react';
import { IRestaurantsContext, RestaurantsContext } from '../restaurantsState/restaurantsContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import Text from 'components/Text/Text';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, archiveSelectedItem, restoreSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IRestaurantsContext>(RestaurantsContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteRestaurant"
				typeOfInfoIcon="toDelete"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="deleteRestaurantDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteRestaurantSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingRestaurant"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'errorActivatedDevices'}
				description="errorWhileDeletingRestaurantDeactivateDevices"
			/>
			<ModalToConfirm
				onConsentEvent={archiveSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmArchiveItem'}
				description="archiveRestaurant"
				typeOfInfoIcon="toArchive"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="archiveRestaurantDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'archiveSuccess'}
				description="archiveRestaurantSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'archiveError'}
				description="errorWhileArchivingRestaurant"
			/>
			<ModalToConfirm
				onConsentEvent={restoreSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmRestoreItem'}
				description="restoreRestaurant"
				typeOfInfoIcon="toRestore"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="restoreRestaurantDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'restoreSuccess'}
				description="restoreRestaurantSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'restoreError'}
				description="errorWhileRestoringRestaurant"
			/>
		</ModalWrapper>
	);
};
